'use client';
import classNames from 'classnames/bind';
import React, { isValidElement } from 'react';
import 'lodash.isempty';
import '../../constants/global.mjs';
import '../../utils/env.mjs';
import IcClose from '../icons/IcClose.mjs';
import ToastWrapper from './ToastWrapper.mjs';
import { TOAST_ANIMATIONS } from '../../constants/toast.mjs';
import usePortal from '../../hooks/usePortal.mjs';
import styles from './ToastAction.module.scss.mjs';

const cx = classNames.bind(styles);
function ToastAction(_ref) {
  let {
    imageComponent,
    children,
    onDestroy,
    onClickCloseButton,
    duration,
    bottomPaddingBase
  } = _ref;
  const Portal = usePortal();
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ToastWrapper, {
    destroy: onDestroy,
    duration: duration,
    animation: TOAST_ANIMATIONS.SLIDE,
    bottomPaddingBase: bottomPaddingBase
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('article')
  }, imageComponent && ( /*#__PURE__*/React.createElement("span", {
    className: cx('area-profile')
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('profile')
  }, imageComponent))), /*#__PURE__*/isValidElement(children) ? ( /*#__PURE__*/React.createElement("p", {
    className: cx('text')
  }, children)) : ( /*#__PURE__*/React.createElement("p", {
    className: cx('text'),
    dangerouslySetInnerHTML: {
      __html: `${children}`
    }
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onClickCloseButton
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 20,
    height: 20,
    fill: "#929294"
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB2EB\uAE30")))));
}
ToastAction.displayName = 'ToastAction';

export { ToastAction as default };
